import { useNavigate } from "react-router-dom";
import { basePath, pathNames } from "../routes/constants";

export const useNav = () => {
  const routerNavigate = useNavigate();

  const goBack = () => {
    routerNavigate(-1);
  };

  const navigate = (path: keyof typeof pathNames) =>
    routerNavigate(`${basePath}/${path}`);

  const goHome = () => routerNavigate(`/`);

  return { goBack, navigate, goHome };
};
